import { BroadcastEvent } from "@enums/BroadcastEvent";
import { IVideoConfigSource } from "@interfaces/IVideo";
import { CanvasService } from "@services/canvas.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IOnChangesObject } from "angular";
import Hls from "hls.js";
import { IVideoSectionLoaded } from "./interfaces/IVideoSectionLoaded";
import "./veriVideo.scss";

interface IVeriVideoComponentBindings {

    onTimeUpdate: (args: { secondsPlayed: number }) => void;
    onLoad: () => void;
    onCanPlay: () => void;
    onPause: () => void;
    onPlay: () => void;
    onSeeking: (args: { currentTime: number }) => void;
    onSeeked: (args: { currentTime: number }) => void;
    onSectionLoaded: (args: { sections: IVideoSectionLoaded[] }) => void;

    videoLabel: string;
}

//interface ICanvasDimensions {
//    x: number;
//    y: number;
//    width: number;
//    height: number;
//}

export interface IVeriVideoComponent {
    play();
    pause();
    restart();
    seek(time: number);
    isPlaying(): boolean;

    getDuration();
    getCurrentTime(): number;
    drawVideoFrame();
}

class VeriVideoComponentController implements angular.IComponentController, IVeriVideoComponentBindings, IVeriVideoComponent {
    sources: IVideoConfigSource[];
    mp4VideoUrl: string;
    webmVideoUrl: string;
    m3u8VideoUrl: string;
    poster: string;
    autoplay: boolean;
    controls: boolean;
    currentposition: number;
    streamPaused: boolean;

    videoLabel: string;

    onTimeUpdate: (args: { secondsPlayed: number }) => void;
    onLoad: () => void;
    onCanPlay: () => void;
    onPause: () => void;
    onPlay: () => void;
    onSeeking: (args: { currentTime: number }) => void;
    onSeeked: (args: { currentTime: number }) => void;
    onSectionLoaded: (args: { sections: IVideoSectionLoaded[] }) => void;
    onError: (args: { error: any }) => void;

    loading: boolean;
    loadingProgress: number;
    showError: boolean;

    videoElement: JQuery;
    videoPlayer: HTMLVideoElement;
    videoElementId: number;

    playbackSpeed = 1;

    //canvasDimensions: ICanvasDimensions;
    //canvasElement: HTMLCanvasElement;
    //canvasContext: CanvasRenderingContext2D;

    lastSecondPlayed = 0;
    correctVideoSizeCount = 0;

    rafNumber: number;

    hlsPlayer: Hls;

    static $inject = ["$timeout", "$scope", "$sce", "$element", "canvasService", "translationService"];

    constructor(
        private readonly $timeout: angular.ITimeoutService,
        private readonly $scope: angular.IScope,
        private readonly $sce: angular.ISCEService,
        private readonly $element: JQuery,
        private readonly canvasService: CanvasService,
        private readonly translationService: TranslationService    ) {
    }

    $onChanges(onChangesObj: IOnChangesObject) {
        if (onChangesObj["currentposition"] && this.videoElement && this.videoPlayer) {
            this.videoPlayer.currentTime = this.currentposition || 0;
        }

        if (onChangesObj["m3u8VideoUrl"] && this.m3u8VideoUrl && this.videoElement && this.videoPlayer) {
            this.loading = true;

            this.hlsPlayer.loadSource(this.m3u8VideoUrl);
            this.hlsPlayer.attachMedia(this.videoPlayer);
        }
        if (onChangesObj["playbackSpeed"] && this.videoElement && this.videoPlayer) {
            this.videoPlayer.playbackRate = this.playbackSpeed;
        }
    }

    $onInit(): void {
        this.sources = [];

        if (this.mp4VideoUrl) {
            this.addVideoSource("mp4");
        }

        if (this.webmVideoUrl) {
            //this.addVideoSource("webm");
        }

        this.updateVideo();

        this.$scope.$on(BroadcastEvent.updateVideoSize, () => {
            //this.setCanvasSize(true);
        });
    }

    $onDestroy() {
        this.destroyPlayer();
    }

    play() {
        this.streamPaused = false;
        this.videoPlayer.play();
    }

    pause() {
        this.streamPaused = true;
        this.videoPlayer.pause();
        if (this.hlsPlayer) {
            this.hlsPlayer.stopLoad();
        }
    }

    restart() {
        this.videoPlayer.currentTime = 0;
        this.videoPlayer.pause();

        if (this.hlsPlayer) {
            this.hlsPlayer.startLoad();
            this.startPauseStreamTimer();
        }
    }

    seek(time: number) {
        this.videoPlayer.currentTime = time;
    }

    getDuration(): number {
        return this.videoPlayer.duration;
    }

    getCurrentTime(): number {
        //console.log("this.videoPlayer.currentTime", this.videoPlayer.currentTime);
        return this.videoPlayer.currentTime;
    }

    isPlaying(): boolean {
        return !this.videoPlayer.paused;
    }

    drawVideoFrame() {
        //if (!this.canvasContext) {
        //    return;
        //}

        //this.canvasContext.drawImage(this.videoPlayer, this.canvasDimensions.x, this.canvasDimensions.y, this.canvasDimensions.width, this.canvasDimensions.height);
    }


    // --------------------------------------------

    private addVideoSource(contentType: string) {

        //src:"https://veruatstorage.file.core.windows.net/commonfiles/37/Videos/db5a4aa6-957e-408a-bc02-45bbec686d28.mp4?sv=2018-03-28&sr=f&sig=6UKX7ctli9uXZjWnwRNixnSbJailPOvlvrdT4L2cKwg%3D&se=2019-11-01T14%3A30%3A49Z&sp=r&rscc=no-cache%2C%20no-store%2C%20must-revalidate",// this.$sce.trustAsResourceUrl(this.videoUrl),

        this.sources.push({
            src: this.$sce.trustAsResourceUrl(this.mp4VideoUrl),
            type: `video/${contentType}`,
            contentType: contentType
        });
    }

    private setupStreamPlayer() {
        //if (Hls.isSupported()) {
        //    return;
        //}

        this.destroyPlayer();

        this.hlsPlayer = new Hls({
            debug: true,
            enableWebVTT: false,
            liveDurationInfinity: true,
            //hlsse
            //capLevelToPlayerSize
            //liveSyncDurationCount: 3,
            autoStartLoad: true,
            enableWorker: true,
            capLevelToPlayerSize: true,
            //capLevelController: true,
            startFragPrefetch: true,
            fragLoadingTimeOut: 60 * 1000 // 5 s timeout
        });

        this.hlsPlayer.attachMedia(this.videoPlayer);

        this.hlsPlayer.on(Hls.Events.MEDIA_ATTACHED, () => {
            console.log("MEDIA_ATTACHED");

            if (this.m3u8VideoUrl) {
                //this.m3u8VideoUrl = this.m3u8VideoUrl.replace("substream", "main");
                //this.m3u8VideoUrl = this.m3u8VideoUrl.replace("9100", "9105");
                //var old = this.m3u8VideoUrl;
                //this.m3u8VideoUrl = "https://mydvr.live:9100/play/0099003A92/1/20200616135555_20200616145742_main.m3u8";
                //this.m3u8VideoUrl = "https://mydvr.live:9100/play/0088021CC4/2/20200615080123_20200615090123_main.m3u8";

                //console.log(" YOYOYOYOYOY", old, this.m3u8VideoUrl);

                //console.warn("playback url", this.m3u8VideoUrl);

                //console.log("time china", 20200616145742 - 20200616135555)
                //console.log("time uk", 20200615090123 - 20200615080123)

                // https://mydvr.live:9100/play/0088021CC4/6/20200615080123_20200615080323_substream.m3u8
                // https://mydvr.live:9100/play/0099003A92/1/20200616135555_20200616145742_main.m3u8
            }

            this.hlsPlayer.loadSource(this.m3u8VideoUrl);
        });

        this.hlsPlayer.on(Hls.Events.MANIFEST_PARSED, (event, data) => {
            console.log("MANIFEST_PARSED", event, data);
            console.log("manifest loaded, found " + data.levels.length + " quality level");

            this.videoPlayer.play();

            console.log("levels", this.hlsPlayer.levels /*this.hlsPlayer.levels this.hlsPlayer.levels*/);
        });

        //this.startPauseStreamTimer();

        this.hlsPlayer.once(Hls.Events.FRAG_LOADED, () => {
            console.log("---LOADEWD");
            //this.videoPlayer.play();
            this.startPauseStreamTimer();
        });

        this.hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
            //console.log('%c Oh my heavens! ', 'background: #eee; color: #bada55', event);

            if (data.fatal) {
                switch (data.type) {
                    case Hls.ErrorTypes.NETWORK_ERROR:
                        // try to recover network error
                        console.log("fatal network error encountered, try to recover");
                        this.hlsPlayer.startLoad();
                        break;

                    case Hls.ErrorTypes.MEDIA_ERROR:
                        console.log("fatal media error encountered, try to recover");
                        this.hlsPlayer.recoverMediaError();
                        break;

                    default:
                        // cannot recover
                        this.hlsPlayer.destroy();
                        if (this.onError) {
                            this.onError({ error: data });
                        }

                        this.videoElement.remove();
                        this.showError = true;
                        break;
                }
            }
        });

        //this.hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
        //    console.log("ERROR", event, data);

        //    if (data.fatal) {
        //        if (this.onError) {
        //            this.onError({ error: data });
        //        }

        //        this.videoElement.remove();
        //        this.showError = true;
        //    }
        //});
    }

    private startPauseStreamTimer() {

        this.$timeout(() => {
            this.pause();
        }, 60 * 1000);
    }

    private updateFakeLoadingProgress() {

        this.$timeout(() => {
            this.loadingProgress += 1;
            //console.log("this.loadingProgress", this.loadingProgress);

            if (this.loading && this.loadingProgress < 100) {
                this.updateFakeLoadingProgress();
            }
        }, 100);
    }

    private updateVideo() {
        this.loading = true;
        this.loadingProgress = 0;
        this.updateFakeLoadingProgress();

        let controlsMarkup = "";
        if (this.controls) {
            controlsMarkup = "controls='controls'";
        }

        let autoplayMarkup = "";
        if (this.autoplay) {
            autoplayMarkup = "autoplay";
        }

        this.videoElementId = Math.floor(Math.random() * 1000);

        // Note this is artififically muted for now
        // For video to play sound remove muted attribute
        var videoHtml = `<video id="${this.videoElementId}" ${controlsMarkup} ${autoplayMarkup} poster="${this.poster}" playsinline muted>`;

        if (this.sources && !this.m3u8VideoUrl) {
            this.sources.forEach(source => {
                videoHtml += `<source src="${source.src}/${source.contentType}" type="${source.type}"/>`;
            });
        }

        videoHtml += `${this.translationService.t('veriVideo.browserNotSupported')}</video>`;

        this.$element.append(videoHtml);
        this.videoElement = this.$element.find("video");
        this.videoPlayer = this.videoElement[0] as HTMLVideoElement;

        if (this.m3u8VideoUrl) {
            console.log("this.m3u8VideoUrl", this.m3u8VideoUrl)
            this.setupStreamPlayer();
        }

        this.videoElement.on("loadedmetadata", () => {
            // Add our player canvas
            //this.setCanvasSize();

            //this.canvasElement = this.canvasService.createHiDPICanvas(this.canvasDimensions.width, this.canvasDimensions.height);
            //this.canvasContext = this.canvasElement.getContext("2d");
            //this.$element.append(this.canvasElement);

            if (this.onLoad) {
                this.$scope.$applyAsync(() => {
                    this.onLoad();
                });
            }

            this.loading = false;
        });

        this.videoElement.on("canplay", () => {
            // console.log("Can play");

            //this.setCanvasSize();

            if (this.onCanPlay) {
                this.$scope.$applyAsync(() => {
                    this.onCanPlay();
                });
            }
        });

        this.videoElement.on("play", (event) => {
            if (this.onPlay) {
                this.$scope.$applyAsync(() => {
                    this.onPlay();
                });
            }
        });

        this.videoElement.on("pause", (event) => {
            if (this.onPause) {
                this.$scope.$applyAsync(() => {
                    this.onPause();
                });
            }
        });

        this.videoElement.on("seeked", (event) => {
            //console.log("Video seek end");

            if (this.onSeeked) {
                this.$scope.$applyAsync(() => {
                    var currentTime = this.getCurrentTime();
                    this.onSeeked({ currentTime: currentTime });
                });
            }
        });

        this.videoElement.on("seeking", (event) => {
            //this.drawVideoFrame();

            //console.log("Video seeking");
            if (this.onSeeking) {
                this.$scope.$applyAsync(() => {
                    var currentTime = this.getCurrentTime();
                    this.onSeeking({ currentTime: currentTime });
                });
            }
        });

        this.videoElement.on("progress", (event) => {
            var seekable: TimeRanges = (this.videoPlayer as any).buffered;
            var sections: IVideoSectionLoaded[] = [];

            for (var si = 0; si < seekable.length; si++) {
                var startSecond = seekable.start(si);
                var endSecond = seekable.end(si);

                sections.push({ startSecond: startSecond, endSecond: endSecond });
            }

            if (this.onSectionLoaded && sections.length) {
                this.$scope.$applyAsync(() => {
                    this.onSectionLoaded({ sections: sections });
                });
            }
        });
    }

    private destroyPlayer() {
        if (!this.hlsPlayer) {
            return;
        }

        this.hlsPlayer.detachMedia();
        this.hlsPlayer.destroy();
    }

    //private setCanvasSize(reset = false) {
    //    if (reset) {
    //        this.correctVideoSizeCount = 0;
    //    }

    //    var currentSize = angular.copy(this.canvasDimensions);

    //    var videoWidth = (this.videoElement[0] as any).videoWidth;
    //    var videoHeight = (this.videoElement[0] as any).videoHeight;

    //    // scale to fit
    //    var containerWidth = this.$element[0].offsetWidth;
    //    var containerHeight = this.$element[0].offsetHeight;

    //    var widthRatio = videoWidth / containerWidth;
    //    var heightRatio = videoHeight / containerHeight;

    //    var scaleByWidth = widthRatio < heightRatio;

    //    var adjustedWidth = scaleByWidth ? videoWidth / widthRatio : videoWidth / heightRatio;
    //    var adjustedHeight = scaleByWidth ? videoHeight / widthRatio : videoHeight / heightRatio;

    //    videoWidth = adjustedWidth;
    //    videoHeight = adjustedHeight;

    //    var videoX = (containerWidth - videoWidth) / 2;
    //    var videoY = (containerHeight - videoHeight) / 2;

    //    this.canvasDimensions = {
    //        x: videoX,
    //        y: videoY,
    //        width: videoWidth,
    //        height: videoHeight
    //    };

    //    this.canvasService.setCanvasDimensions(this.canvasElement, this.canvasContext, this.canvasDimensions.width, this.canvasDimensions.height);

    //    var isCorrectSize = containerHeight != 0 && angular.equals(this.canvasDimensions, currentSize);
    //    if (isCorrectSize) {
    //        this.correctVideoSizeCount++;
    //    }

    //    var timeoutValue = 50;
    //    if (this.correctVideoSizeCount <= 1000 / timeoutValue) {
    //        this.$timeout(() => {
    //            this.setCanvasSize();
    //        }, timeoutValue);
    //    }
    //}
}

export class VeriVideoComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            sources: "<",
            poster: "<",
            controls: "<",
            mp4VideoUrl: "<?",
            webmVideoUrl: "<?",
            m3u8VideoUrl: "<?",
            playbackSpeed: "<",
            //sources:"@",
            videoLabel: "@",

            currentposition: "<",
            autoplay: "<",

            onTimeUpdate: "&",
            onLoad: "&",
            onCanPlay: "&",
            onPlay: "&",
            onPause: "&",
            onSeeking: "&",
            onSeeked: "&",
            onSectionLoaded: "&",
            onError: "&"
        };

        this.require = {
            videoCollection: "^^?videoCollection"
        };
        this.controller = VeriVideoComponentController;
        this.template = require("./veriVideo.html");
    }
}
